<script>
    import { onMount } from 'svelte';
    export let classId;
    export let classStart = null;
    export let label = "More Info"; // Optional label for the button
    export let buttonClass = 'base'; // Default class is 'base'
    const expiredMessage = 'Nuo pamokos pradžios praėjo 14 dienų. Atsiliepimo pateikti ar koreguoti nebegalima.';
    // The rollout starts at midnight on 1 November in Europe/Vilnius (UTC+2).
    const cutoffAppliesFrom = new Date('2026-11-01T00:00:00+02:00').getTime();
    let now = new Date().getTime();
    $: startTime = classStart ? new Date(classStart).getTime() : NaN;
    $: deadline = startTime >= cutoffAppliesFrom ? startTime + 14 * 24 * 60 * 60 * 1000 : Infinity;
    $: expired = now >= deadline;
    onMount(() => {
        const timer = setInterval(() => { now = new Date().getTime(); }, 1000);
        return () => clearInterval(timer);
    });
    function openComment() {
        now = new Date().getTime();
        if (now >= deadline) return;
        window.location.href = `#/leave-comment/${classId}`;
    }
</script>

<!-- The disabled button cannot receive focus; its group lets keyboard users read the explanation. -->
<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div class="comment-button" tabindex={expired ? 0 : undefined} role="group" aria-label={label} aria-describedby={expired ? `comment-deadline-${classId}` : undefined}>
<button on:click={openComment} class={buttonClass} disabled={expired} aria-label={expired ? `${label}. ${expiredMessage}` : label}>
    <span>{label}</span>
</button>
{#if expired}
    <div class="deadline-explanation" role="tooltip" id={`comment-deadline-${classId}`}>
        <strong>Atsiliepimo terminas baigėsi</strong>
        <span>{expiredMessage}</span>
    </div>
{/if}
</div>
<style>
    .comment-button { position: relative; width: 100%; }
    .comment-button:focus-visible { outline: 2px solid #14695b; outline-offset: 4px; border-radius: 8px; }
    .deadline-explanation {
        position: absolute;
        z-index: 20;
        bottom: calc(100% + 10px);
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
        width: min(340px, 100%);
        padding: 14px 16px;
        border: 1px solid #14695b;
        border-radius: 8px;
        background: #fffffa;
        color: #333;
        box-shadow: 0 4px 12px rgba(20, 105, 91, 0.12);
        text-align: left;
        line-height: 1.5;
        cursor: default;
        visibility: hidden;
    }
    .deadline-explanation strong { display: block; margin-bottom: 5px; color: #14695b; font-size: 14px; font-weight: 600; }
    .deadline-explanation span { display: block; font-size: 13px; font-weight: 400; }
    .deadline-explanation::before {
        content: '';
        position: absolute;
        bottom: -6px;
        left: calc(50% - 5px);
        width: 10px;
        height: 10px;
        background: #fffffa;
        border-right: 1px solid #14695b;
        border-bottom: 1px solid #14695b;
        transform: rotate(45deg);
    }
    .deadline-explanation::after { content: ''; position: absolute; bottom: -12px; left: 0; width: 100%; height: 12px; }
    .comment-button:hover .deadline-explanation,
    .comment-button:focus-within .deadline-explanation { visibility: visible; }
    button:disabled, button:disabled:hover {
        background-color: #e0e0e0;
        color: #666;
        border-color: #aaa;
        cursor: not-allowed;
        box-shadow: none;
        pointer-events: none;
    }
    .comment-button:has(button:disabled) { cursor: not-allowed; }
    /* Button styling */
    button span {
        font-weight: bolder;
        font-size:larger;
    }

    button {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 12px 20px;
        gap: 10px;
    
        width: 100%;
        height: 60px;
    
        /* Purple background */
        background-color: #faad4a;
    
        /* Black border */
        border: 2px solid black;
        color:black;
    
        /* Box shadow */
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
    
        /* Rounded corners */
        border-radius: 8px;
    
        /* Inside auto layout */
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
    
        /* Remove default button styling */
        outline: none;
        cursor: pointer;
  
        /* Remove the default button background on focus */
        background-image: none;
        transition: background-color 0.3s ease, color 0.3s ease;
    }

    /* Button hover effect */
    button:hover {
        background-color: #14695b;
        color:white;
        border: 2px solid #14695b;
    }
    .koregouti{
        background-color: white;
        color: black;
        border: 2px solid #000000;
    }
    .koregouti:hover{
        background-color:#14695b;
        color:white;
        border: 2px solid #14695b;
        
    }

    /* Text inside the button */
    span {
        font-size: 1rem;
        font-weight: bold;
        
    }
</style>
